import { render, staticRenderFns } from "./CreateUpdateBatchQcTest.vue?vue&type=template&id=38771175&scoped=true&"
import script from "./CreateUpdateBatchQcTest.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateBatchQcTest.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateBatchQcTest.vue?vue&type=style&index=0&id=38771175&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38771175",
  null
  
)

export default component.exports